import { Component, OnInit } from '@angular/core';
import { Label, MultiDataSet, SingleDataSet, monkeyPatchChartJsTooltip, monkeyPatchChartJsLegend, Color } from 'ng2-charts';
import { ChartType, ChartOptions, ChartDataSets } from 'chart.js';
import { AdminServicesService } from '../admin-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dashboardmain-admin',
  templateUrl: './dashboardmain-admin.component.html',
  styleUrls: ['./dashboardmain-admin.component.css']
})
export class DashboardmainAdminComponent implements OnInit {

  // Variables for storing API data

  public a: number;
  public b: number;
  public c: number;
  public d: number;
  public e: number;
  public f: number;

  // Donut Chart for Total users with verification

  doughnutChartLabels: Label[] = ['Mobile Not Verified', 'Mobile Verified'];
  doughnutChartData: MultiDataSet = [[this.a, this.b]];

  doughnutChartType: ChartType = 'doughnut';


  // Pie chart for categories Active & In-Active
  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartLabels: Label[] = [['Active'], ['In-Active']];
  public pieChartData: SingleDataSet = [this.c,this.d];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];

  // Bar chart for downloads

  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: Label[] = ['Downloaded', 'Not Downloaded'];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];
  lineChartColors: Color[] = [
    {
      backgroundColor: ["#88aef2", "#ff8c8ce3"]
    },
  ];
  barChartData: ChartDataSets[] = [
    { data: [0, this.e , this.f], label: 'Downloads' }
  ];


  constructor(public admin: AdminServicesService,
    public router: Router,
    public toastr: ToastrService) {

    // for Categories
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
  }

  ngOnInit(): void {
    
    this.admin.chart().subscribe((res: any) => {
      if (res.code === 200) {
        this.a = Number(res.data[0].Mobile_Not_Verified);
        this.b = Number(res.data[0].Mobile_Verified);
        this.c = Number(res.data[0].Active_Categories);
        this.d = Number(res.data[0].In_Active_Categories);
        this.e = Number(res.data[0].Downloaded_Files);
        this.f = Number(res.data[0].Not_Downloaded_Files);
        this.doughnutChartData = [[this.a, this.b]];
        this.pieChartData = [this.c, this.d];
        this.barChartData[0].data = [this.e, this.f, 0];
      } else {
        console.log(res.message)
      }
    }, (err) => {
      console.log(err);
    });
  }
}
